import { Injectable } from '@angular/core';

@Injectable()
export class  webConfig {
  
    public LFD = 'http://180.178.132.147:8002/';
    // public aws = 'http://34.235.163.113:8001/';
    public prod = 'http://10.40.1.233:8001/';
    public local = 'http://localhost:8001/';
    public url = this.LFD;
}


// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/webconfig.ts